module.exports = __webpack_public_path__ + "fonts/G9qizdsn.woff";